<template>
  <div class="about">
    <h2>プロフィール</h2>
    <h3>近畿大学工学部情報学科</h3>

    <p>
      Mail :
      <a href="mailto:1810990019g@hiro.kindai.ac.jp"
        >1810990019g@hiro.kindai.ac.jp</a
      >
    </p>
    <p>
      Github :
      <a href="https://github.com/masa-dev" target="_blank" rel="noopener"
        >https://github.com/masa-dev</a
      >
    </p>

    <h3>使用言語</h3>
    <ul>
      <li>C</li>
      <li>HTML / CSS / SCSS</li>
      <li>JavaScript</li>
    </ul>

    <h3>フレームワーク / ライブラリ</h3>
    <ul>
      <li>Vue.js</li>
      <li>jQuery</li>
      <li>Bootstrap</li>
    </ul>

    <h3>使用ツールなど</h3>
    <ul>
      <li>Visual Studio Code</li>
      <li>Git / Github</li>
    </ul>
  </div>
</template>

<script>
export default {
  title: "About me",
};
</script>
